var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-page-detail",class:( _obj = {
    'is-single': _vm.single
  }, _obj[("row-amount-" + _vm.rowAmount)] = _vm.rowAmount !== 1, _obj )},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }